import React, { Suspense, lazy } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { CurrencyProvider } from "./context/CurrencyContext";
import Header from "./components/Header";
import Footer from "./components/Footer";
import FloatingWhatsApp from "./components/FloatingWhatsApp";
import Home from "./pages/Home";
import CatalogPage from "./pages/Catalog";
import CatCatalogPage from "./pages/CatCatalogPage";
import ContactPage from "./pages/Contact";
import AdminPage from "./pages/AdminPage";
import PaymentPage from "./pages/PaymentPage";
import SuccessPage from "./pages/SuccessPage";
import CancelPage from "./pages/CancelPage";
import CatPaymentPage from "./pages/CatPaymentPage";

const Veterinaria = lazy(() => import("./pages/Veterinaria"));
const Blog = lazy(() => import("./pages/Blog"));
const BlogPost = lazy(() => import("./pages/BlogPost"));
const Escuela = lazy(() => import("./pages/Escuela"));
const Leccion = lazy(() => import("./pages/Leccion"));

const LoadingFallback = () => (
  <div className="min-h-screen bg-black flex items-center justify-center">
    <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-yellow-400"></div>
  </div>
);

const App = () => {
  return (
    <HelmetProvider>
      <CurrencyProvider>
        <Router>
          <div className="min-h-screen bg-black">
            <Header />
            <Suspense fallback={<LoadingFallback />}>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/catalogo" element={<CatalogPage />} />
                <Route path="/catalogo-gatos" element={<CatCatalogPage />} />
                <Route path="/contacto" element={<ContactPage />} />
                <Route path="/admin" element={<AdminPage />} />
                <Route path="/payment" element={<PaymentPage />} />
                <Route path="/cat-payment" element={<CatPaymentPage />} />
                <Route path="/success" element={<SuccessPage />} />
                <Route path="/cancel" element={<CancelPage />} />
                <Route path="/veterinaria" element={<Veterinaria />} />
                <Route path="/blog" element={<Blog />} />
                <Route path="/blog/:slug" element={<BlogPost />} />
                <Route path="/escuela" element={<Escuela />} />
                <Route path="/escuela/:id" element={<Leccion />} />
              </Routes>
            </Suspense>
            <Footer />
            <FloatingWhatsApp />
          </div>
        </Router>
      </CurrencyProvider>
    </HelmetProvider>
  );
};

export default App;
